module.exports = __webpack_public_path__ + "img/arrow-right-long.55a50235.svg";